import { Outlet } from "react-router-dom";
import Header from "components/Header";
import SidebarMain from "components/SidebarMain";

const DefaultLayout = () => {
  return (
    <div className="dark:bg-[#EBEEF5] dark:text-bodydark sm:overflow-auto overflow-hidden flex flex-col h-screen">
      {/* Header */}
      <Header />

      {/* Main content area with flex-1 to take remaining space */}
      <div className="flex flex-1 overflow-hidden sm:overflow-auto p-4 sm:p-2.5 gap-4 h-full">
        {/* Sidebar - sticky and scrollable if needed */}
        <SidebarMain className="sticky top-0 z-50 w-[265px] bg-white-A700 h-full md:hidden overflow-y-auto" />

        {/* Main content container - flex-1 and overflow-auto */}
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DefaultLayout;
